import BottomNavigation from "@mui/material/BottomNavigation";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";
import Typography from "@mui/material/Typography";
import MapIcon from '@mui/icons-material/Map';
import SettingsIcon from '@mui/icons-material/Settings';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import RecyclingIcon from '@mui/icons-material/Recycling';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism';

import { useLocation, Link } from "react-router-dom";
import { useCookies } from "react-cookie";
import { Avatar } from "@mui/material";
import { useTranslation } from "react-i18next";

function MyBottomNavigation(): JSX.Element {

    const location = useLocation();
    const [cookies, setCookie, removeCookie] = useCookies(['recotech_mapapps_token']);
    const { t } = useTranslation();

    return (
        <>
            {cookies.recotech_mapapps_token?
            <BottomNavigation
                value={location.pathname}
            >
                {/* パディング用 */}
                <BottomNavigationAction/>
                <BottomNavigationAction/>
                <BottomNavigationAction
                    label={
                        <Typography variant="body2" sx={{ fontSize: "10px" }}>
                            {t('component.myBottomNavigation.map')}
                        </Typography>
                    }
                    value="/"
                    icon={<MapIcon />}
                    component={Link}
                    to="/"
                />

                <BottomNavigationAction
                    label={
                        <Typography variant="body2" sx={{ fontSize: "10px" }}>
                            {t('component.myBottomNavigation.bookmark')}
                        </Typography>
                    }
                    value="/bookmark"
                    icon={<BookmarkIcon />}
                    component={Link}
                    to="/bookmark"
                />

                <BottomNavigationAction
                    label=""
                    value="/checkin"
                    icon={<RecyclingIcon sx={{ width:50, height:50, borderRadius: '100%'}} />}
                    component={Link}
                    to="/checkin"
                />

                <BottomNavigationAction
                    label={
                        <Typography variant="body2" sx={{ fontSize: "10px" }}>
                            {t('component.myBottomNavigation.ecoScore')}
                        </Typography>
                    }
                    value="/wallet"
                    icon={<VolunteerActivismIcon />}
                    component={Link}
                    to="/wallet"
                />

                <BottomNavigationAction
                    label={
                        <Typography variant="body2" sx={{ fontSize: "10px" }}>
                            {t('component.myBottomNavigation.setting')}
                        </Typography>
                    }
                    value="/setting"
                    icon={<SettingsIcon />}
                    component={Link}
                    to="/setting"
                />
                {/* パディング用 */}
                <BottomNavigationAction/>
                <BottomNavigationAction/>
            </BottomNavigation>
            :
            <BottomNavigation
                value={location.pathname}
                showLabels
            >
                {/* パディング用 */}
                <BottomNavigationAction/>
                <BottomNavigationAction/>
                <BottomNavigationAction/>
                <BottomNavigationAction/>
                <BottomNavigationAction
                    label={
                        <Typography variant="body2" sx={{ fontSize: "10px" }}>
                            {t('component.myBottomNavigation.map')}
                        </Typography>
                    }
                    value="/"
                    icon={<MapIcon />}
                    component={Link}
                    to="/"
                />
                <BottomNavigationAction
                    label={
                        <Typography variant="body2" sx={{ fontSize: "10px" }}>
                            {t('component.myBottomNavigation.howTo')}
                        </Typography>
                    }
                    value="/howto"
                    icon={<Avatar alt={t('component.myBottomNavigation.addToHomescreen')} src={(location.pathname==="/howto")?"favicon2.ico":"favicon.ico"} sx={{ width: 24, height: 24, borderRadius: 0 }}/>}
                    component={Link}
                    to="/howto"
                />                
                <BottomNavigationAction
                    label={
                        <Typography variant="body2" sx={{ fontSize: "10px" }}>
                            {t('component.myBottomNavigation.login')}
                        </Typography>
                    }
                    value="/login"
                    icon={<ExitToAppIcon />}
                    component={Link}
                    to="/login"
                />
                {/* パディング用 */}
                <BottomNavigationAction/>
                <BottomNavigationAction/>
                <BottomNavigationAction/>
                <BottomNavigationAction/>
            </BottomNavigation>
            }
        </>
    );
};

export default MyBottomNavigation;
